import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from './dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogServiceService {

  constructor(private Dialog : MatDialog) { }

  OpenSampleDialoge = () =>
  {
    this.Dialog.open(DialogComponent,{
      width:'70%',
      height:"90%",
      disableClose :true,

    })
  }
}
